var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('scale-box',{attrs:{"width":1920,"height":1080,"bgc":"transparent","isFlat":true,"delay":100}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }